import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { findIndex, isEmpty } from "lodash";
import { makeStyles, Paper, Typography, Grid, Fab, Chip } from "@material-ui/core";
import { Face, Add } from "@material-ui/icons";

import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 40,
    marginBottom: 40
  },
  title: {
    ...theme.typography.subtitle2,
    marginBottom: 20
  }
}));

const Members = ({
  t,
  onChangeData,
  title,
  filteredList,
  handleSearchMember,
  voto,
  committeeMembers,
  disabled,
  dataApiRequestMembers
}) => {
  const classes = useStyles();
  const [value, setValue] = useState({});
  const [fill, setFill] = useState(true);
  const [memberListSelected, setMemberListSelected] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let newList = [...filteredList];
    if(newList.length > 0) {
      let memberIds = new Set(memberListSelected.map(({ id }) => id));
      dataApiRequestMembers.memberListSelected.forEach(({id}) => memberIds.add(id));
      newList =  newList.filter(({ id }) => !memberIds.has(id));
    }
    setOptions(newList);
  }, [filteredList]);


  useEffect(() => {
    if (committeeMembers.length > 0 && fill) {
      fillCommittee(committeeMembers);
    }
  }, [committeeMembers]);

  const fillCommittee = (items) => {
    setMemberListSelected(items);
    setFill(false);
  };

  const handleAddMember = () => {
    if (!isEmpty(value)) {
      const idx = memberListSelected.indexOf(value)
      if(idx !== -1) memberListSelected.splice(idx,1);

      const newMemberList = [...memberListSelected];
      newMemberList.push({ ...value, isHaveRightToVote: voto });
      setMemberListSelected(newMemberList);
      onChangeData({ id: value.id, isHaveRightToVote: voto }, "add");
      setValue({});     
    }
  };

  const handleInputChange = (value) => {
    handleSearchMember(value);
   };

  const handleDelete = (id) => {
    const newMemberList = [...memberListSelected];
    const idx = findIndex(newMemberList, ["id", id]);

    newMemberList.splice(idx, 1);
    setMemberListSelected(newMemberList);
    onChangeData(
      {
        id: memberListSelected[idx].id,
        isHaveRightToVote: voto,
      },
      "remove"
    );
  };

  return (
    <Paper elevation={1} className={classes.root}>
      <Typography className={classes.title}>
        {title}
      </Typography>
      <Grid container alignItems="center" spacing={3}>
        <Grid item lg={10} xs={12}>
          <Autocomplete
            id="members"
            autoComplete={false}
            options={options}
            getOptionLabel={(options) => {
              if(options.name) return `${options.name} - ${options.positionName}`;
              else return "";
            }}
            onChange={(event, newValue) => setValue(newValue)}
            onSelect={() => setOptions([])}
            getOptionSelected={(option, value) => option.id === value.id}
            onInputChange={_.debounce((event, newValue) => {
              if(newValue.length > 2) handleInputChange(newValue);
            }, 500)}
            disabled={disabled}
            value={value}
            renderInput={(params) => (
              <TextField {...params} label="" fullWidth />
            )}
          />
        </Grid>
        <Grid item lg={2} xs={12}>
          <Fab
            color="primary"
            aria-label="add"
            size="small"
            onClick={handleAddMember}
            disabled={disabled}
          >
            <Add />
          </Fab>
        </Grid>
        {memberListSelected.map((item, index) => (
          <Grid item lg={12} xs={12} key={`${item} - ${index}`}>
            <Chip
              icon={<Face />}
              label={item.positionName ? `${item.name} - ${item.positionName}` : item.isExternal ? `${item.name} (Externo)` : item.name}
              onDelete={() => handleDelete(item.id)}
              color="primary"
              disabled={disabled}
              style={item.isExternal ? { borderStyle: "dashed" } : {}}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default withTranslation()(Members);
